import * as amplitude from '@amplitude/analytics-browser';

import {
  mapQuickPageNavigation,
  mapQuickGalleryNavigation,
  mapReportListingSubmittedEventData,
  mapSharedOfferEventData,
  mapViewOfferPage,
  mapRequestToBookEventData,
  mapAuthenticateWithVerificationCodeData,
  mapPromocodeVerificationEventData
} from '@spa/shared/hooks/tracking/services/amplitude/mappers';

const EVENT_MAPPER = {
  'quick-page-navigation': mapQuickPageNavigation,
  'quick-gallery-navigation': mapQuickGalleryNavigation,
  'report-listing-submit': mapReportListingSubmittedEventData,
  'shared-offer': mapSharedOfferEventData,
  'view-offer-page': mapViewOfferPage,
  'request-to-book': mapRequestToBookEventData,
  'authenticate-with-verification-code': mapAuthenticateWithVerificationCodeData,
  'promocode-verification-successful': mapPromocodeVerificationEventData,
  'promocode-verification-failed': mapPromocodeVerificationEventData
};

export const initAmplitude = (apiKey, userId = null) => {
  amplitude.init(apiKey, {
    serverZone: 'EU',
    userId,
    autocapture: false
  });
};

const eventNamesWithoutSuffix = [
  'booking-flow-step1-completed',
  'booking-flow-step3-payment-details-added',
  'booking-flow-step3-billing-details-added',
  'back-to-search-clicked',
  'click-upload-document',
  'upload-document-success',
  'upload-document-failure'
];

const track = ({ page, event, ...eventData }) => {
  const matchedEvent = eventNamesWithoutSuffix.find(e => event.startsWith(e));

  if (matchedEvent) {
    amplitude.track(matchedEvent);

    return Promise.resolve();
  }

  const mapEventData = EVENT_MAPPER[event] || (eventData => eventData);
  const mappedEventData = mapEventData(eventData);

  if (Object.keys(mappedEventData).length === 0) {
    amplitude.track(event);

    return Promise.resolve();
  }

  return new Promise(resolve => {
    amplitude.track(event, mappedEventData);
    resolve();
  });
};

export default { track };
